
  export default {
    name: 'ThemeStoresMobileIosFooter'
  }
